import { jsx, jsxs } from 'react/jsx-runtime';
import { useMemo } from 'react';
import classNames from 'classnames';
import { Icon } from '../../Icon/Icon.es.js';
import { useVerticalStepperContext } from '../VerticalStepper.Context/VerticalStepper.Context.es.js';
import { VerticalStepperStepWrapper } from '../VerticalStepper.StepWrapper/VerticalStepper.StepWrapper.es.js';

const VerticalStepperChildStep = ({ isActive = false, isStepComplete = false, isHidden = false, label, ...rest })=>{
    const { isFlowComplete = false } = useVerticalStepperContext();
    const isComplete = isFlowComplete || isStepComplete;
    const iconName = useMemo(()=>{
        if (isComplete) {
            return 'CheckOutline';
        }
        if (isActive) {
            return 'EllipseSolid';
        }
        return 'EllipseOutline';
    }, [
        isActive,
        isComplete
    ]);
    if (isHidden) {
        return null;
    }
    return jsx("li", {
        className: classNames('cb-vertical-stepper-child-step'),
        children: jsxs(VerticalStepperStepWrapper, {
            ...rest,
            children: [
                jsx(Icon, {
                    className: classNames('child-step-icon', {
                        active: isActive,
                        inactive: !isActive
                    }),
                    name: iconName,
                    size: 20
                }),
                jsx("span", {
                    className: classNames('child-step-label', {
                        active: isActive,
                        inactive: !isActive
                    }),
                    children: label
                })
            ]
        })
    });
};
VerticalStepperChildStep.displayName = 'VerticalStepper.ChildStep';

export { VerticalStepperChildStep };
//# sourceMappingURL=VerticalStepper.ChildStep.es.js.map
